import UserStore from "../../../store/user-store";
import PaymnetStore from "../../../store/paymnet-store";
import {apiClient} from "../../../AxiosConfig";
const apiUrl = process.env.REACT_APP_API_URL;

export const getUserPlans = async () => {
    apiClient.get("/v1/plans/" ).then(data => {
        if (data.status === 200) {
            console.log(data.data)
            UserStore.setPlanDataAfterPayment(data.data)
            PaymnetStore.setIsPaymentUrlOpened(false)
            return;
        }

    });
}